import React from 'react';
import DateTimeDisplay, { padTime } from './DateTimeDisplay';
import { UseCountdown } from './UseCountdown';


const ShowCounter = ({ days, hours, minutes, seconds }) => {
  return (
    <div className="countdown">
      <DateTimeDisplay value={days} type={'ימים'} isDanger={days <= 3} />
      <DateTimeDisplay value={hours} type={'שעות'} isDanger={false} />
      <DateTimeDisplay value={minutes} type={'דקות'} isDanger={false} />
      <DateTimeDisplay value={seconds} type={'שניות'} isDanger={false} />
    </div>
  );
};

// one line version for tight spots, e.g. "12 ימים · 04:20:11"
const ShowCompactCounter = ({ days, hours, minutes, seconds }) => {
  return (
    <div className="countdown-compact">
      <strong>{days}</strong> ימים · <span dir="ltr">{padTime(hours)}:{padTime(minutes)}:{padTime(seconds)}</span>
    </div>
  );
};

const CountdownTimer = ({ targetDate, compact = false }) => {
  const [days, hours, minutes, seconds] = UseCountdown(targetDate);

  // NaN when the event date couldn't be parsed - show nothing rather than "NaN"
  if (isNaN(days) || days + hours + minutes + seconds <= 0) return null;

  const Counter = compact ? ShowCompactCounter : ShowCounter;
  return (
    <Counter
      days={days}
      hours={hours}
      minutes={minutes}
      seconds={seconds}
    />
  );
};

export default CountdownTimer;
